export const toCamelCase = (str: string): string => {
  return (
    str.charAt(0).toLowerCase() +
    str.slice(1).replace(/([-_][a-z])/gi, ($1) => {
      return $1.toUpperCase().replace("-", "").replace("_", "");
    })
  );
};

export const toPascalCase = (str: string): string => {
  const camelCaseStr = toCamelCase(str);
  return camelCaseStr.charAt(0).toUpperCase() + camelCaseStr.slice(1);
};

export const toKebabCase = (str: string): string => {
  return (
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|[a-z]+[0-9]*|[0-9]+)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      ?.map((x) => x.toLowerCase())
      .join("-") || ""
  );
};

export const pluralize = (input: string): string => {
  if (!input) {
    return input;
  }

  if (input.endsWith("y")) {
    return input.slice(0, -1) + "ies";
  } else if (
    input.endsWith("s") ||
    input.endsWith("sh") ||
    input.endsWith("ch") ||
    input.endsWith("x") ||
    input.endsWith("z")
  ) {
    return input + "es";
  } else if (input.endsWith("f")) {
    return input.slice(0, -1) + "ves";
  } else if (input.endsWith("fe")) {
    return input.slice(0, -2) + "ves";
  } else if (input.endsWith("us")) {
    return input.slice(0, -2) + "i";
  } else if (input.endsWith("is")) {
    return input.slice(0, -2) + "es";
  } else if (input.endsWith("on") || input.endsWith("um")) {
    return input.slice(0, -2) + "a";
  } else {
    return input + "s";
  }
};

export const singularize = (input: string): string => {
  if (!input) {
    return input;
  }

  if (input.endsWith("ies")) {
    return input.slice(0, -3) + "y";
  } else if (
    input.endsWith("shes") ||
    input.endsWith("ches") ||
    input.endsWith("xes") ||
    input.endsWith("zes") ||
    input.endsWith("ses")
  ) {
    return input.slice(0, -2);
  } else if (input.endsWith("ves")) {
    if (input.endsWith("ives")) {
      return input.slice(0, -3) + "ife";
    }
    return input.slice(0, -3) + "f";
  } else if (input.endsWith("i")) {
    return input.slice(0, -1) + "us";
  } else if (input.endsWith("a")) {
    return input.slice(0, -1) + "um";
  } else if (input.endsWith("s")) {
    return input.slice(0, -1);
  } else {
    return input;
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("toCamelCase", toCamelCase);
  nuxtApp.provide("toPascalCase", toPascalCase);
  nuxtApp.provide("toKebabCase", toKebabCase);
  nuxtApp.provide("pluralize", pluralize);
  nuxtApp.provide("singularize", singularize);
});
